/* tslint:disable */
import { PackingElmt } from './packing-elmt';

/**
 */
export class ViewPackingElmt {
    mine?: PackingElmt[];
    others?: PackingElmt[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-packing-elmt.ts